import { createSvgIcon } from '@mui/material/utils'

const NGLogo = createSvgIcon(
    <svg
        width="84"
        height="59"
        viewBox="0 0 84 59"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M30 30C30 36.6304 32.6339 42.9893 37.3223 47.6777C42.0107 52.3661 48.3696 55 55 55C61.6304 55 67.9893 52.3661 72.6777 47.6777C77.3661 42.9893 80 36.6304 80 30L55 30L30 30Z"
            fill="#38A2F2"
        />
        <rect x="55" y="4" width="25" height="25" fill="#F3B85F" />
        <rect x="4" y="30" width="25" height="25" fill="#52D498" />
        <path
            d="M54 29C54 22.3696 51.3661 16.0107 46.6777 11.3223C41.9893 6.63392 35.6304 4 29 4C22.3696 4 16.0107 6.63392 11.3223 11.3223C6.63392 16.0107 4 22.3696 4 29L29 29H54Z"
            fill="#F26359"
        />
    </svg>,
    'Adjustments'
)

export default NGLogo
